import NameFilter from './NameFilter.component';

export default NameFilter;
